<template>
  <div class="step-container">
    <div class="row center">
      <h3 class="step-header">3. Is your boiler under guarantee?</h3>
    </div>
    <div class="row center">
      <h4 class="step-sub-header">Boilers under guarantee don't need cover, just the system</h4>
    </div>
    <div class="row center">
      <button class="submit-button" @click="$emit('submit', 0)">
        <img class="btn-icon" :src="`${base}images/yes.png`" alt="Yes icon">
        <span>Yes</span>
      </button>
      <button class="submit-button" @click="$emit('submit', 1)">
        <img class="btn-icon" :src="`${base}images/no.png`" alt="No icon">
        <span>No</span>
      </button>
      <button class="submit-button" @click="$emit('submit', 2)">
        <img class="btn-icon" :src="`${base}images/other-room.png`" alt="Not sure icon">
        <span>Not Sure</span>
      </button>
    </div>
    <div class="row center back">
      <span @click="$emit('back')">Back</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepThree",
  props: {
    base: {
      type: String,
      required: true,
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/steps/StepThree.vue